import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Icon } from '@ohif/ui';

import DateRange from '../DateRange';
import InputLabelWrapper from '../InputLabelWrapper';

const InputDateRange = ({
  id,
  label,
  isSortable,
  sortDirection,
  onLabelClick,
  value,
  onChange,
  dateType,
  onDateTypeChange,
}) => {
  const { t } = useTranslation('StudyList');
  const { startDate, endDate } = value || {};

  const onClickHandler = event => {
    event.preventDefault();
    onLabelClick(event);
  };

  const isProcessedAt = dateType === 'processedAt';
  const effectiveLabel = isProcessedAt ? t('ProcessedAt') : label;

  const handleToggle = event => {
    event.preventDefault();
    event.stopPropagation();
    if (onDateTypeChange) {
      onDateTypeChange(isProcessedAt ? 'studyDate' : 'processedAt');
    }
  };

  const headerExtra = onDateTypeChange && (
    <button
      type="button"
      onClick={handleToggle}
      title={
        isProcessedAt
          ? t('SwitchToStudyDate')
          : t('SwitchToProcessedAt')
      }
      className="rounded transition-all duration-200 cursor-pointer border border-white/20 hover:bg-indigo-500/50 hover:border-indigo-400/40"
    >
      <Icon name="replace" className="w-4 h-4 text-indigo-400" />
    </button>
  );

  return (
    <InputLabelWrapper
      label={effectiveLabel}
      isSortable={isSortable}
      sortDirection={sortDirection}
      onLabelClick={onClickHandler}
      headerExtra={headerExtra}
    >
      <div className="relative">
        <DateRange
          id={id}
          startDate={startDate}
          endDate={endDate}
          onChange={onChange}
        />
      </div>
    </InputLabelWrapper>
  );
};

const noop = () => {};

InputDateRange.defaultProps = {
  value: {},
  onLabelClick: noop,
  dateType: 'studyDate',
  onDateTypeChange: null,
};

InputDateRange.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  isSortable: PropTypes.bool.isRequired,
  sortDirection: PropTypes.oneOf(['ascending', 'descending', 'none']).isRequired,
  onLabelClick: PropTypes.func.isRequired,
  value: PropTypes.shape({
    /** YYYYMMDD (19921022) */
    startDate: PropTypes.string,
    /** YYYYMMDD (19921022) */
    endDate: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  dateType: PropTypes.oneOf(['studyDate', 'processedAt']),
  onDateTypeChange: PropTypes.func,
};

export default InputDateRange;
